import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'

const ScrollArrowButtons = ({ scrollLeft, scrollRight, color = false }) => {
  return (
    <>
      <button onClick={scrollLeft} className={`p-2 md:p-3 rounded-full ${color ? 'bg-white text-primaryFadedColor hover:bg-primaryColor' : ' bg-[#292C6F73] text-white hover:bg-primaryColor'} transition-colors duration-300`}><FaChevronLeft /></button>
      <button onClick={scrollRight} className={`p-2 md:p-3 rounded-full ${color ? 'bg-white text-primaryFadedColor hover:bg-primaryColor' : ' bg-[#292C6F73] text-white hover:bg-primaryColor'} transition-colors duration-300`}><FaChevronRight /></button>
    </>
  )
}

export default ScrollArrowButtons